// extracted by mini-css-extract-plugin
module.exports = {"footerContainer":"ClientWallet_footerContainer__USXJu","savePackageButton":"ClientWallet_savePackageButton__1VEuP"};